import React from "react";

/**
 * AdSlot – delineated advertisement zone.
 * Renders the Google AdSense slot when an ad slot id is provided, otherwise
 * shows a clearly labelled placeholder so the layout stays intact.
 */
export default function AdSlot({ variant = "leaderboard", testid }) {
  const dims = {
    leaderboard: { minH: 120, label: "728 × 90 / responsive" },
    sidebar: { minH: 320, label: "300 × 250" },
    inline: { minH: 100, label: "Responsive in-content" },
  }[variant] || { minH: 100, label: "Responsive" };

  return (
    <div
      className="ad-slot w-full"
      style={{ minHeight: dims.minH }}
      data-testid={testid || `ad-slot-${variant}`}
      aria-label="Advertisement"
    >
      <div className="opacity-60">Sponsored space · {dims.label}</div>
    </div>
  );
}
